import {
  setPlayerDebugMode,
  setLogger as setPlayerLogger,
} from '@setplex/player'
import { api } from '@setplex/tria-api'
import {
  adapter,
  setLogger as setAdapterLogger,
} from '@setplex/tria-api-adapter-nora'
import { Logger } from '~/shared/logger'
import { env } from '~/shared/config'
import { requestPolicy } from './policies'
import { request } from './request'
import { deviceModel } from '../device'

export { onBucketsUpdate } from './policies'

api.use(adapter({ $deviceType: deviceModel.$deviceType }))
api.fx.use(request)

/**
 * Get current Request Policy status,
 * either it is enforced for some request groups or not
 */
export function isRequestPolicyEnforced(): boolean {
  return requestPolicy.isEnforced()
}

// set logger for a adapter and player
setAdapterLogger(new Logger('adapter'))
setPlayerLogger(new Logger('player'))

// set debug mode for player errors
if (env.TRIA_CLIENT_PLAYER_DEBUG) {
  setPlayerDebugMode(env.TRIA_CLIENT_PLAYER_DEBUG)
}
